import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";

export default function Header() {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        { code: "fr", label: "Français", countryCode: "FR" },
        { code: "en", label: "English", countryCode: "GB" },
        { code: "es", label: "Español", countryCode: "ES" },
    ];

    const currentLang =
        languages.find((l) => l.code === i18n.language) || languages[0];

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
        localStorage.setItem("lang", lng);
    };

    return (
        <div className="flex flex-col justify-center items-center self-stretch p-[20px] rounded-[20px] bg-white/5 backdrop-blur-[37px] w-full fixed top-0 z-50">
            <div className="flex justify-between items-center w-full max-w-screen-lg">
                {/* Logo */}
                <img className="h-20" src="/logo_qovoltis.svg" alt="Qovoltis" />

                {/* Sélecteur de langue */}
                <div className="relative">
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-md"
                    >
                        <ReactCountryFlag
                            countryCode={currentLang.countryCode}
                            svg
                            style={{ width: "1.5em", height: "1.5em" }}
                            className="rounded-full"
                        />
                        <span className="hidden md:inline">{currentLang.label}</span>
                        <span className="md:hidden inline" >{currentLang.code}</span>
                    </button>

                    {isOpen && (
                        <div className="absolute mt-2 w-40 bg-white rounded-lg shadow-lg">
                            {languages.map((lang) => (
                                <button
                                    key={lang.code}
                                    onClick={() => changeLanguage(lang.code)}
                                    className="flex items-center gap-2 w-full px-4 py-2 text-left hover:bg-gray-100"
                                >
                                    <ReactCountryFlag
                                        countryCode={lang.countryCode}
                                        svg
                                        style={{ width: "1.5em", height: "1.5em" }}
                                        className="rounded-full"
                                    />
                                    <span className="hidden md:inline">{lang.label}</span>
                                    <span className="md:hidden inline" >{lang.code}</span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
